import React from 'react';
import { Form, Formik } from 'formik';
import { connect } from 'react-redux';
import { IonAlert, IonContent, IonPage } from '@ionic/react';
import intl, { Text } from '$gintl';

import { authActions } from '$gbusiness/redux/auth';
import { Header } from '$gcomponents/widgets';
import { screen } from '$gcomponents/hoc';
import { FormSection, LogoHeader } from '$gcomponents/reusables';
import { Box, SPACE, Space } from '$gstyles';
import { ROUTES } from '$gbusiness/enums';
import { input } from '$ghelpers';

import FORGOT_FORM from './forgotForm';
import { Button, Link } from '$gcomponents/primitives';

interface ForgotScreenProps {
  requestPasswordReset: Function;
  screenState: any;
  history: any;
}

const ForgotPasswordScreen: React.FC<ForgotScreenProps> = ({
  requestPasswordReset,
  screenState,
  history,
}) => {
  const onSubmit = values => requestPasswordReset(values.email);

  const validateForm = values => input.validateError(FORGOT_FORM, values);

  return (
    <IonPage id="forgot-screen">
      <Header title="SCREEN.FORGOT.TITLE" />
      <IonContent>
        <IonAlert
          isOpen={screenState !== ''}
          header={intl('MESSAGE.SUBMITTED')}
          message={intl('MESSAGE.PASSWORD_RESET')}
          onDidDismiss={() => {
            history.goBack();
          }}
          buttons={['OK']}
        />
        <Box.LARGE>
          <LogoHeader />
          <Formik
            enableReinitialize={true}
            initialValues={{}}
            validate={validateForm}
            onSubmit={values => {
              onSubmit(values);
            }}>
            {formik => (
              <Box.MEDIUM padding={SPACE.SMALL}>
                <Form>
                  <FormSection title="SCREEN.FORGOT.SUBTITLE" FORM={FORGOT_FORM} formik={formik} />
                  <Button onClick={formik.handleSubmit} disabled={!(formik.isValid && formik.dirty)}>
                    <Text k="SCREEN.FORGOT.SUBMIT_BUTTON" />
                  </Button>
                </Form>
                <Space.Ver margin={SPACE.LARGE}>
                  <Link route={ROUTES.LOGIN} routerDirection="back" button>
                    <Text k="SCREEN.FORGOT.LOGIN_LINK" />
                  </Link>
                </Space.Ver>
              </Box.MEDIUM>
            )}
          </Formik>
        </Box.LARGE>
      </IonContent>
    </IonPage>
  );
};

const mapStateToProps = state => ({
  loading: state.loading,
  screenState: state.routing.screenState,
});

const mapDispatchToProps = {
  requestPasswordReset: authActions.requestPasswordReset,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(ForgotPasswordScreen));
